import type { ChatToolStep } from '../../lib/assistant'

/**
 * What the assistant looked at (agent-1-web W3): one chip per tool step, its
 * `label` verbatim from the server (C35: generic while running, specific when
 * done -- "Opening a card…", then "Opened the Mental activation card").
 *
 * `aria-live="off"`: the steps change several times a second while a turn
 * runs, and announcing each would drown the reply. The reply itself is
 * announced by the thread's live region.
 */
export function Trace({ steps }: { steps: readonly ChatToolStep[] }) {
  if (steps.length === 0) return null
  return (
    <ul className="assistant-trace" aria-label="What the assistant looked at" aria-live="off">
      {steps.map((step, i) => (
        <li key={`${step.tool}-${i}`} className={`assistant-trace__step assistant-trace__step--${step.status}`}>
          <StepGlyph status={step.status} />
          <span>{step.label}</span>
        </li>
      ))}
    </ul>
  )
}

function StepGlyph({ status }: { status: ChatToolStep['status'] }) {
  if (status === 'running') {
    return (
      <svg className="assistant-trace__spinner" width="11" height="11" viewBox="0 0 24 24" fill="none" aria-hidden="true">
        <path d="M12 3a9 9 0 1 0 9 9" stroke="currentColor" strokeWidth="2.6" strokeLinecap="round" />
      </svg>
    )
  }
  if (status === 'failed') {
    return (
      <svg width="11" height="11" viewBox="0 0 24 24" fill="none" aria-hidden="true">
        <path d="M12 7v6M12 17h.01" stroke="currentColor" strokeWidth="2.6" strokeLinecap="round" />
      </svg>
    )
  }
  return (
    <svg width="11" height="11" viewBox="0 0 24 24" fill="none" aria-hidden="true">
      <path d="M20 6L9 17l-5-5" stroke="currentColor" strokeWidth="2.6" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  )
}
